








import Vue from "vue";
import Tile from "./Tile.vue";

export default Vue.extend({
  name: "Displayed",
  props: ["displayed"],
  components: {
    Tile
  }
});
